<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-card v-if="!loading&&fields&&fields.length>0&&idMapArray">
            <v-card-title class="primary white--text title">
                {{title}}
            </v-card-title>
            <v-card-text>
                <v-layout row wrap v-if="description&&description!==''">
                    <v-flex xs12 >
                        <p>{{description}}</p>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-if="!tableMode">
                    <v-flex xs12>
                        <v-text-field :label="'Time'|translate" type="datetime-local"
                                      v-model="payload.timestamp"></v-text-field>
                    </v-flex>
                    <v-flex xs12 v-for="field in fields">
                        <v-text-field v-if="idMapArray[field.sensor]" :label="field.label" :hint="field.hint"  v-model.number="payload[idMapArray[field.sensor]]" :clearable="!field.required" type="number"
                                      :rules="field.required ? [(v) => !!v || 'This field is required'] : []"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-if="tableMode">
                    <table class="generic-styled-table" style="width:100%">
                        <thead>
                        <tr>
                            <th v-if="multipleMode">{{ 'Time'|translate }}</th>
                            <th v-for="field in fields" v-if="idMapArray[field.sensor]">{{ field.label }}</th>
                            <th v-if="multipleMode"></th>
                        </tr>
                        </thead>
                        <tbody v-if="!multipleMode">
                        <tr>
                            <td v-for="field in fields" v-if="idMapArray[field.sensor]" class="pa-0 ma-0">
                                <v-text-field hide-details v-model.number="payload[idMapArray[field.sensor]]" type="number" class="ma-0 pa-0 text-right-tablefield"></v-text-field>
                            </td>
                        </tr>
                        </tbody>
                        <tbody v-if="multipleMode">
                        <tr v-for="(row,rowIndex) in multiPayload">
                            <td class="pa-0 ma-0">
                                <v-text-field hide-details v-model="row.timestamp" type="datetime-local"  class="ma-0 pa-0 text-right-tablefield"></v-text-field>
                            </td>
                            <td v-for="field in fields" v-if="idMapArray[field.sensor]" class="pa-0 ma-0">
                                <v-text-field hide-details v-model.number="row[idMapArray[field.sensor]]" type="number" class="ma-0 pa-0 text-right-tablefield"></v-text-field>
                            </td>
                            <td class="ma-0 pa-0">
                                    <v-icon small @click="multiPayload.splice(rowIndex,1)" class="table-form-icon ma-0 pa-0">
                                        fa-trash
                                    </v-icon>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </v-layout>

            </v-card-text>
            <v-card-actions>
                <v-btn class="primary elevation-4 ml-2" @click="addRow">{{'Add Row'|translate}}</v-btn>
                <v-spacer></v-spacer>
                <span style="width:220px;" v-if="tableMode&&!multipleMode"><v-text-field :label="'Time'|translate" type="datetime-local" class="mr-3"
                                                                          v-model="payload.timestamp"></v-text-field></span>

                <v-btn class="primary elevation-4 mr-2" @click="save">{{'Submit'|translate}}</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import {callAPI} from '@/helper'
import LoadingProgressBar from './../LoadingProgressBar'
import moment from "moment";

export default {
    props: {
        title: {type: String, default: null},
        description: {type: String, default: null},
        tableMode: {type: Boolean, default: false},
        multipleMode: {type: Boolean, default: false},
        fields: {type: Array},
    },
    components: {LoadingProgressBar},
    computed: {},
    name: 'FormWidget',
    data: function () {
        return {
            loading: false,
            payload:{
                timestamp:moment().format("YYYY-MM-DD HH:mm:ss"),
            },
            multiPayload:[
                {
                    timestamp:moment().format("YYYY-MM-DD HH:mm:ss"),
                }
            ],
            idMapArray:null
        }
    },
    beforeMount() {
        let idMapArray = {}
        for (let item of this.$store.state.pointsListStore.pointsList.points_list){
            idMapArray[item.equipment_name + " - " + item.sensor_name] = item.sensor_id
        }
        this.idMapArray=idMapArray
    },
    methods: {
        addRow(){
            this.multiPayload.push({
                timestamp:moment().format("YYYY-MM-DD HH:mm:ss"),
            })
        },
        async save(){
            this.loading = true
            if (this.multipleMode&&this.tableMode){
                for (let row of this.multiPayload){
                    let payload = JSON.parse(JSON.stringify(row))
                    payload.timestamp = moment(payload.timestamp).format("YYYY-MM-DD HH:mm:ss")
                    await callAPI('wide-upload/',payload)
                }
                this.multiPayload=[
                    {
                        timestamp:moment().format("YYYY-MM-DD HH:mm:ss"),
                    }
                ]
            } else {
                let payload = JSON.parse(JSON.stringify(this.payload))
                payload.timestamp = moment(payload.timestamp).format("YYYY-MM-DD HH:mm:ss")
                await callAPI('wide-upload/',payload)
                this.payload = {
                    timestamp:moment().format("YYYY-MM-DD HH:mm:ss"),
                }
            }

            this.loading = false
            await this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Data uploaded')})
        }

    },
}

</script>

<style>
.text-right-tablefield .v-input__control .v-input__slot input {
    text-align: right;
}
</style>
